// App
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

// Hooks
import { useDemographics } from './hooks';

// Components
import SrpContentWrapper from 'app/shared/modules/MobileSRP/__BaseComponents__/SrpContentWrapper';

// Misc / utils
import * as S from './styles';

const Demographics = () => {
  // Redux
  const demographicData = useSelector((state: RootReduxState) => state.area.facts);
  const { parsedFacts } = useDemographics(demographicData);

  if (parsedFacts.length < 1) {
    return null;
  }

  return (
    <SrpContentWrapper identifier={'demographics'} title={'Demographic highlights'}>
      <section>
        {parsedFacts.map((fact) => {
          const label = fact.label;
          const value = fact.value;

          return (
            <Fragment key={`demographic-${fact.label}-fact-${fact.value}-answer`}>
              <S.Label>{label}</S.Label>
              <S.Value>{value}</S.Value>
            </Fragment>
          );
        })}
      </section>
    </SrpContentWrapper>
  );
};

export default Demographics;
